const MAP = {
  pending: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  pending_auth: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  pending_payment: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  authorized: "bg-blue-500/10 text-blue-400 border-blue-500/20",
  paid: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  active: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  completed: "bg-zinc-500/10 text-zinc-400 border-zinc-600/20",
  cancelled: "bg-red-500/10 text-red-400 border-red-500/20",
  refunded: "bg-red-500/10 text-red-400 border-red-500/20",
  open: "bg-blue-500/10 text-blue-400 border-blue-500/20",
  in_progress: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  waiting_user: "bg-violet-500/10 text-violet-400 border-violet-500/20",
  escalated: "bg-red-500/10 text-red-400 border-red-500/20",
  resolved: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  closed: "bg-zinc-500/10 text-zinc-400 border-zinc-600/20",
  urgent: "bg-red-500/10 text-red-400 border-red-500/20",
  high: "bg-orange-500/10 text-orange-400 border-orange-500/20",
  normal: "bg-zinc-500/10 text-zinc-400 border-zinc-600/20",
  low: "bg-zinc-500/10 text-zinc-500 border-zinc-600/20",
  available: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
  occupied: "bg-amber-500/10 text-amber-400 border-amber-500/20",
};

export default function StatusBadge({ value }) {
  const v = String(value || "").toLowerCase();
  const cls = MAP[v] || "bg-zinc-500/10 text-zinc-400 border-zinc-600/20";
  return (
    <span data-testid={`status-${v || "unknown"}`}
          className={`inline-flex items-center px-2.5 py-1 rounded-md text-[10px] font-semibold uppercase tracking-[0.1em] border ${cls}`}>
      {v.replace(/_/g, " ") || "unknown"}
    </span>
  );
}
